<template>
  <div class="hero-body">
    <div class="container has-text-centered">
      <div v-if="loading" class="loading">
        <progress class="progress is-medium is-dark" max="100">45%</progress>
      </div>
      <transition :name="slideDirection()" v-if="showQuestion">
        <multichoice
          v-if="question.kind === 'multichoice'"
          :question="question"
          :key="question.id"
        ></multichoice>
        <casegrid
          v-if="question.kind === 'casegrid'"
          :question="question"
          :key="question.id"
        ></casegrid>
        <VisuwellUser
          v-if="question.kind === 'visuwell_user'"
          :question="question"
          :key="question.id"
        >
        </VisuwellUser>
        <ondemand
          v-if="question.kind === 'ondemand'"
          :question="question"
          :key="question.id"
        ></ondemand>
        <multitext
          v-if="question.kind === 'multitext'"
          :question="question"
          :key="question.id"
        ></multitext>
        <date
          v-if="question.kind === 'date'"
          :question="question"
          :key="question.id"
        ></date>
        <email
          v-if="question.kind === 'email'"
          :question="question"
          :key="question.id"
        ></email>
        <phone
          v-if="question.kind === 'phone'"
          :question="question"
          :key="question.id"
        ></phone>
        <zip
          v-if="question.kind === 'zip'"
          :question="question"
          :key="question.id"
        ></zip>
        <location
          v-if="question.kind === 'location'"
          :question="question"
          :key="question.id"
        ></location>
        <dropdown
          v-if="question.kind === 'dropdown'"
          :question="question"
          :key="question.id"
        ></dropdown>
        <schedule
          v-if="question.kind === 'schedule'"
          :question="question"
          :key="question.id"
        ></schedule>
        <single-text
          v-if="question.kind === 'singletext'"
          :question="question"
          :key="question.id"
        ></single-text>
        <checkbox
          v-if="question.kind === 'checkbox'"
          :question="question"
          :key="question.id"
        ></checkbox>
        <file
          v-if="question.kind === 'file'"
          :question="question"
          :key="question.id"
        ></file>
        <stripe
          v-if="question.kind === 'stripe'"
          :question="question"
          :key="question.id"
        ></stripe>
        <instruction
          v-if="question.kind === 'instruction'"
          :question="question"
          :key="question.id"
        ></instruction>
        <VideoInstruction
          v-if="question.kind === 'video'"
          :question="question"
          :key="question.id"
        ></VideoInstruction>
        <AsyncCase
          v-if="question.kind === 'async_case'"
          :question="question"
          :key="question.id"
        ></AsyncCase>
      </transition>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import multichoice from "@/components/questions/multichoice";
import casegrid from "@/components/questions/casegrid";
import ondemand from "@/components/questions/ondemand";
import multitext from "@/components/questions/multitext";
import date from "@/components/questions/date";
import email from "@/components/questions/email";
import phone from "@/components/questions/phone";
import zip from "@/components/questions/zip";
import location from "@/components/questions/location";
import dropdown from "@/components/questions/dropdown";
import schedule from "@/components/questions/schedule";
import singleText from "@/components/questions/singleText";
import checkbox from "@/components/questions/checkbox";
import file from "@/components/questions/file";
import stripe from "@/components/questions/stripe";
import instruction from "@/components/questions/instruction";
import VideoInstruction from "@/components/questions/VideoInstruction";
import PatientQueuesService from "../services/PatientQueuesService";
import VisuwellUser from "@/components/questions/VisuwellUser";
import AsyncCase from "@/components/questions/AsyncCase";
// noinspection JSUnusedLocalSymbols
export default {
  name: "interview",

  components: {
    multichoice,
    casegrid,
    ondemand,
    multitext,
    date,
    email,
    phone,
    zip,
    location,
    dropdown,
    schedule,
    singleText,
    checkbox,
    file,
    stripe,
    instruction,
    VideoInstruction,
    VisuwellUser,
    AsyncCase
  },

  beforeRouteUpdate(to, from, next) {
    // force the logo to show on the summary page
    window.scrollTo(0, 0);

    this.$store.dispatch("interview/updatePreviousQuestion", {
      page: to.params.p,
      question: to.params.q
    });
    next();
  },

  // watch: {
  //   patientQueueId(newVal, oldVal) {
  //     if (oldVal == null) {
  //       let params = this.$route.params;
  //       params["id"] = newVal;
  //       debugger
  //       this.$router.push({ name: "interview", params: params });
  //     }
  //   },
  // },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    question() {
      return this.$store.getters["interview/question"](
        this.$route.params.p,
        this.$route.params.q
      );
    },
    showQuestion() {
      return _.has(this.question, "kind");
    },
    patientQueueId() {
      return this.$store.state.interview.patientQueue.id;
    }
  },

  mounted() {
    this.$store.dispatch(
      "interview/setPage",
      parseInt(this.$route.params.p, 10)
    );
    this.$store.dispatch(
      "interview/setQuestion",
      parseInt(this.$route.params.q, 10)
    );
    if (!this.patientQueueId) {
      let patientQueueId = this.$route.params.id;
      this.loading = true;
      PatientQueuesService.fetch(patientQueueId)
        .then(() => {
          //It was successful
          this.loading = false;
        })
        .catch(error => {
          if (error.response.status == 403) {
            console.error(`Not authorized for ${patientQueueId}`);
            alert(
              "Your session has timed out and you will have to start over."
            );
            this.loading = false;
            this.$router.push({ name: "home" });
          } else {
            alert("Something went wrong. Please try again.");
          }
        });
    }
  },

  methods: {
    slideDirection() {
      return this.$store.getters["interview/transition"];
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.next-leave-active,
.next-enter-active,
.previous-leave-active,
.previous-enter-active {
  transition: all 0.3s ease;
}

.next-enter {
  transform: translate(100%, 0);
  position: absolute;
}
.next-leave-to {
  transform: translate(-100%, 0);
  position: absolute;
}

.previous-enter {
  transform: translate(-100%, 0);
  position: absolute;
}
.previous-leave-to {
  transform: translate(100%, 0);
  position: absolute;
}
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  min-height: 70vh;
}
.loading progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
}
</style>
